import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import * as ApiRoute from 'constants/apiRouting'

import NoticeHelper from 'helpers/notice'
import { SAVE_FORM } from './reducer'
import { SHOW_NOTICE } from '../notice'

function* saveFeedbackForm(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.SAVE_FEEDBACK_FORM,
      method: 'POST',
      data: action.payload.form,
    })

    if (response.error) {
      return yield call(action.promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(action.payload.successMessage),
    })

    return yield call(action.promise.resolve, false)
  } catch (error) {
    console.log('FEEDBACK SEND FAILED ', error)
  }
}

function* feedbackSaga() {
  yield takeLatest(SAVE_FORM, saveFeedbackForm)
}

export default feedbackSaga
